import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Telegram = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      {...rest}
    >
      <path
        d="M15.3306 1.40274C15.4708 1.52633 15.5304 1.71779 15.4851 1.89911L12.374 14.3436C12.3303 14.5183 12.196 14.6561 12.0224 14.7041C11.8488 14.7522 11.6627 14.7032 11.5353 14.5758L8.0541 11.0946L6.06667 13.7445C5.95509 13.8933 5.77015 13.9678 5.58658 13.9381C5.40301 13.9083 5.25114 13.779 5.19233 13.6026L3.70227 9.13243L0.776396 7.6695C0.599507 7.58105 0.491372 7.39666 0.50054 7.1991C0.509709 7.00155 0.634459 6.82796 0.81878 6.75628L14.8188 1.31184C14.993 1.2441 15.1904 1.27916 15.3306 1.40274ZM8.35964 9.98592C8.35595 9.98212 8.35219 9.97836 8.34836 9.97465L7.92933 9.55562L10.6869 6.79806C10.8822 6.6028 10.8822 6.28622 10.6869 6.09095C10.4916 5.89569 10.175 5.89569 9.97978 6.09095L6.86867 9.20207C6.67341 9.39733 6.67341 9.71391 6.86867 9.90917L7.33981 10.3803L5.83924 12.3811L4.58546 8.61973C4.54352 8.49392 4.45333 8.38993 4.33472 8.33063L2.23243 7.27948L14.2805 2.59411L11.618 13.2443L8.35964 9.98592Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

Telegram.displayName = 'Telegram';
